import { Component, OnInit } from '@angular/core';

import { HeaderStateService } from '../headers/services/header-state.service';

@Component({
    selector: 'app-root',
    templateUrl: './root.component.html',
    styleUrls: ['./root.component.scss']
})
export class RootComponent implements OnInit {

    constructor(
        public headerStateService: HeaderStateService
    ) { }

    ngOnInit(): void {

    }
}
